// src/auth-config.tsx

/**
 * MSAL (Microsoft Authentication Library) configuration.
 */
export const msalConfig = {
  auth: {
    clientId: "d71b0fb8-da1f-4036-9a77-f33353f11e8f", // Application (client) ID from Azure AD App Registration
    authority: "https://login.microsoftonline.com/51f2b3db-607d-4a08-a529-2539e6a1e20d", // Tenant ID or "common" for multi-tenant
   // redirectUri: "http://localhost:3000",  // ^ Development redirect URI
     redirectUri: "https://uat.enminvithaigal.in/", // ^ Production redirect URI (uncomment for live server)
  },
  cache: {
    cacheLocation: "localStorage", // Options: "localStorage" or "sessionStorage"
    storeAuthStateInCookie: false, // Set to true for IE11/Edge compatibility
  },
};

/**
 * Request object for login popup/redirect.
 * Using ".default" scope ensures all delegated Graph API permissions
 * granted in Azure AD App Registration are requested at once.
 */
export const loginRequest = {
  scopes: ["https://graph.microsoft.com/.default"],
};
